<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// 隔离作用域，避免全局变量的污染
!(function () {
  function setHtmlFontSize() {
    var whdef = 16 / 375; // 表示1920的设计图,使用100PX的默认值
    var bodyWidth = document.documentElement.getBoundingClientRect().width; // 当前窗口的宽度
    console.log(bodyWidth, "屏幕宽度");
    var rem = Math.ceil(bodyWidth * whdef * 10) / 10; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
    document.getElementsByTagName("html")[0].style.cssText = "font-size:"+ rem +"px!important;";
  }
  setHtmlFontSize();
  window.addEventListener("resize", function () {
    setTimeout(function () {
      setHtmlFontSize();
    }, 100);
  });
})();
</script>


<style lang="scss">
html,
body,
input,
a {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  list-style: none;
  border-width: 0;
  text-decoration: none;
}

#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  a {
    text-decoration: none;
  }
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
